document.documentElement.classList.add('strex-js');

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function reveal(scope = document) {
  const elements = scope.querySelectorAll('[data-strex-reveal]:not([data-strex-ready])');

  if (reducedMotion.matches || !('IntersectionObserver' in window)) {
    elements.forEach((element) => {
      element.dataset.strexReady = 'true';
      element.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
  );

  elements.forEach((element) => {
    element.dataset.strexReady = 'true';
    observer.observe(element);
  });
}

document.addEventListener('DOMContentLoaded', () => reveal());
document.addEventListener('shopify:section:load', (event) => reveal(event.target));
